/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2021-2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { camelCase, reduce } from "lodash";
import Vue from 'vue';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const mdiSvgIcons = reduce(require('@mdi/js'), (icons, value, key) => {
    icons[key] = value

    return icons
}, {} as Record<string, string>)
mdiSvgIcons.mdiPolygonMatic = "M29,10.2c-0.7-0.4-1.6-0.4-2.4,0L21,13.5l-3.8,2.1l-5.5,3.3c-0.7,0.4-1.6,0.4-2.4,0L5,16.3 c-0.7-0.4-1.2-1.2-1.2-2.1v-5c0-0.8,0.4-1.6,1.2-2.1l4.3-2.5c0.7-0.4,1.6-0.4,2.4,0L16,7.2c0.7,0.4,1.2,1.2,1.2,2.1v3.3l3.8-2.2V7 c0-0.8-0.4-1.6-1.2-2.1l-8-4.7c-0.7-0.4-1.6-0.4-2.4,0L1.2,5C0.4,5.4,0,6.2,0,7v9.4c0,0.8,0.4,1.6,1.2,2.1l8.1,4.7 c0.7,0.4,1.6,0.4,2.4,0l5.5-3.2l3.8-2.2l5.5-3.2c0.7-0.4,1.6-0.4,2.4,0l4.3,2.5c0.7,0.4,1.2,1.2,1.2,2.1v5c0,0.8-0.4,1.6-1.2,2.1 L29,28.8c-0.7,0.4-1.6,0.4-2.4,0l-4.3-2.5c-0.7-0.4-1.2-1.2-1.2-2.1V21l-3.8,2.2v3.3c0,0.8,0.4,1.6,1.2,2.1l8.1,4.7 c0.7,0.4,1.6,0.4,2.4,0l8.1-4.7c0.7-0.4,1.2-1.2,1.2-2.1V17c0-0.8-0.4-1.6-1.2-2.1L29,10.2z"

export const mdiSvg = (icon: null | string): string | null => {
    if (!icon) {
        return null
    }

    return mdiSvgIcons[camelCase(icon)] || null
}

Vue.filter('fileIcon', (extension: string): string => {
    const associations: Record<string, string> = {
        "jpg": "mdiFileJpgBox",
        "jpeg": "mdiFileJpgBox",
        "png": "mdiFilePngBox",
        "pdf": "mdiFilePdfBox",
        "txt": "mdiTextBox",
        "doc": "mdiFileWordBox",
        "docx": "mdiFileWordBox",
        "xls": "mdiFileExcelBox",
        "xlsx": "mdiFileExcelBox",
    }

    return associations[extension] || 'mdiFileOutline'
})

Vue.filter('mdiSvg', mdiSvg)
